export const AllCampaignsStatusIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='38'
    height='8'
    viewBox='0 0 38 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='8' height='8' rx='4' fill='#2DB0A9' />
    <rect x='10' width='8' height='8' rx='4' fill='#FCAF17' />
    <rect x='20' width='8' height='8' rx='4' fill='#EF4444' />
    <rect x='30' width='8' height='8' rx='4' fill='#94A3B8' />
  </svg>
);
export const AllButArchived = (props) => (
  <svg
    style={{ ...props?.style }}
    width='38'
    height='8'
    viewBox='0 0 38 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='10' width='8' height='8' rx='4' fill='#2DB0A9' />
    <rect x='20' width='8' height='8' rx='4' fill='#FCAF17' />
    <rect x='30' width='8' height='8' rx='4' fill='#EF4444' />
  </svg>
);

export const FieldOnly = (props) => (
  <svg
    style={{ ...props?.style }}
    width='38'
    height='8'
    viewBox='0 0 38 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='38' height='8' rx='4' fill='inherit' />
  </svg>
);
